import { Icon, Row, Text } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const Circle = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 22px;
  border: 2px solid ${theme.SECONDARY};

  @media (max-width: 1024px) {
    width: 16px;
    height: 16px;
    border: 1.5px solid ${theme.SECONDARY};
  }
`;

const CheckContainer = styled.div`
  position: absolute;
  top: -9px;
  left: 0;

  @media (max-width: 1024px) {
    top: -5px;
  }
`;

const Checkbox = ({ selected, text, handleSelect, marg }) => {
  const { isMobile } = global;

  return (
    <Row pointer center onClick={handleSelect} marg={marg}>
      <Circle>
        {selected && (
          <CheckContainer>
            <Icon type="check" dimensions={isMobile ? 22 : 30} col={theme.SECONDARY} />
          </CheckContainer>
        )}
      </Circle>

      {text && (
        <Text
          med
          size={isMobile ? '20px' : '30px'}
          col={theme.SECONDARY}
          marg={`0 0 0 ${isMobile ? '8px' : '15px'}`}
        >
          {text}
        </Text>
      )}
    </Row>
  );
};

export default Checkbox;
